import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { UpdateNotificationResponse } from './types';

type UpdateNotificationParams = {
  memberId: string;
  campaignId: string;
  status: boolean;
};

export async function updateMemberNotification({ memberId, campaignId, status }: UpdateNotificationParams) {
  const url = `/web/studio/users/${memberId}/notifications/${campaignId}`;

  const response = await api.executePutRequest<ObjectResponse<UpdateNotificationResponse>>(url, { status });

  return response.data;
}
